import type { ButtonHTMLAttributes } from 'react'
import React from 'react'
import classNames from 'classnames'

import type { BaseButtonProps } from './BaseButton'
import { BaseButton, BaseButtonContent } from './BaseButton'

export type ButtonProps = ButtonHTMLAttributes<HTMLElement> &
  Omit<BaseButtonProps, 'children'> & { ref?: React.Ref<HTMLButtonElement> }

export function Button({
  variant,
  size,
  icon,
  iconShape,
  iconColor,
  iconVariant,
  iconClassName,
  iconPosition,
  iconSize,
  children,
  disabled,
  forbiddenWhenDisabled,
  className,
  style,
  isActive,
  rounded,
  transparent,
  align,
  ref,
  ...props
}: ButtonProps) {
  return (
    <BaseButton
      variant={variant}
      size={size}
      disabled={disabled}
      forbiddenWhenDisabled={forbiddenWhenDisabled}
      isActive={isActive}
      rounded={rounded}
      transparent={transparent}
      align={align}
    >
      {(outerClassName, outerStyle, innerClassName, innerStyle) => (
        <button
          {...props}
          ref={ref}
          disabled={disabled}
          type={props.type ?? 'button'}
          className={classNames(className, outerClassName)}
          style={{ ...outerStyle, ...style }}
        >
          <div className={innerClassName} style={innerStyle}>
            <BaseButtonContent
              icon={icon}
              iconShape={iconShape}
              iconColor={iconColor}
              iconVariant={iconVariant}
              iconClassName={iconClassName}
              content={children}
              size={size}
              iconPosition={iconPosition}
              iconSize={iconSize}
            />
          </div>
        </button>
      )}
    </BaseButton>
  )
}
